"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PointsOfSaleWithMenuMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class PointsOfSaleWithMenuMapper {
    toDomain(result) {
        const data = lodash_1.default.get(result, "data.getUser.currentHoldingView.getPos.edges");
        const isLoading = lodash_1.default.get(result, "loading");
        return {
            data,
            isLoading,
        };
    }
}
exports.PointsOfSaleWithMenuMapper = PointsOfSaleWithMenuMapper;
